import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { ChangeWorkOrderStageDesiredStartTime } from "@interfaces/dto/changeWorkOrderStageDesiredStartTime.interface";
import { ChangeWorkOrderStageEstimatedStartDate } from "@interfaces/dto/changeWorkOrderStageEstimatedStartDate.interface";
import { ChangeWorkOrderStageMachine } from "@interfaces/dto/changeWorkOrderStageMachine.interface";
import { ChangeWorkOrderStageOperator } from "@interfaces/dto/changeWorkOrderStageOperator.interface";
import { ChangeWorkOrderStageOperatorPriority } from "@interfaces/dto/changeWorkOrderStageOperatorPriority.interface";
import { ChangeWorkOrderStagePriority } from "@interfaces/dto/changeWorkOrderStagePriority.interface";
import { Service } from "@services/service";

@Injectable()
export class WorkOrderStageService extends Service {
	constructor(injector: Injector) {
		super("WorkOrderStage", injector);
	}

	app_togglePause(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_TogglePause/${id}`, {});
	}

	changeDesiredStartTime(data: ChangeWorkOrderStageDesiredStartTime){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeDesiredStartTime`, data);
	}

	changeEstimatedStartDate(data: ChangeWorkOrderStageEstimatedStartDate){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeEstimatedStartDate`, data);
	}

	changeMachine(data: ChangeWorkOrderStageMachine){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeMachine`, data);
	}

	changeOperator(data: ChangeWorkOrderStageOperator){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeOperator`, data);
	}

	changeOperatorPriority(data: ChangeWorkOrderStageOperatorPriority){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeOperatorPriority`, data);
	}

	changePriority(data: ChangeWorkOrderStagePriority){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangePriority`, data);
	}

	completedQuantity(id: number, quantity: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CompletedQuantity/${id}/${quantity}`, {});
	}

	completedQuantityApiKey(id: number, quantity: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_IncreaseCompletedQuantity/${id}/${quantity}`, {});
	}

	getForWorkOrder(id: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForWorkOrder/${id}`);
	}

	increaseScrapAmount(id: number, quantity: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_IncreaseScrappedQuantity/${id}/${quantity}`, {});
	}

	machineTrainingRequiredForAssignment() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/MachineTrainingRequiredForAssignment`);
	}

	nextOperator(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/NextOperator/${id}`, {});
	}

	recalculateEstimates(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/RecalculateEstimates/${id}`, {});
	}

	reduceQuantity(id: number, quantity: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ReduceQuantity/${id}/${quantity}`, {});
	}

	requiredAmountAdjustment(id: number, quantity: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_AdjustQuantity/${id}/${quantity}`, {});
	}

	togglePause(id: number){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/TogglePause/${id}`, {});
	}
}